<button mat-raised-button class="button1 mb-2" (click)="GenerarReportePerformanceBudget()">Buscar</button>
<div class="a-w1-column">
    <div class="a-w1-row">
        <div class="a-w2 graficos" [ngClass]="{'sindata': dataReporteLinea.length <= 0}">
            <div class="titulos-graficos">GENERAL POR EJECUTIVO (2024)*</div>
            <table>
                <tr class="cabecera">
                    <td class="items-cabecera cabecera-cuadros">Ejecutivo</td>
                    <td class="items-cabecera center">*BudM</td>
                    <td class="items-cabecera center">TEU</td>
                    <td class="items-cabecera center">%BudM</td>
                    <td class="items-cabecera center">VarBudM</td>
                    <td class="items-cabecera center">Clientes</td>
                    <td class="items-cabecera center">OV</td>
                </tr>
                <tr *ngFor="let item of dataReporteLinea; let i = index" class="contenido-final"
                    [ngClass]="{'sombra': (i % 2) == 0}">
                    <td class="items-contenido items-ejecutivos">{{item.entc_nomcompleto}}</td>
                    <td class="items-contenido center">
                        {{item.monto}}</td>
                    <td class="items-contenido center"
                        [ngClass]="{'red': item['cantidad'] < item['monto'],'green':item['cantidad'] >= item['monto']}">
                        {{item.cantidad}}
                    </td>
                    <td class="items-contenido center"
                        [ngClass]="{'red': item['cantidad'] < item['monto'],'green':item['cantidad'] >= item['monto']}">
                        {{(item.porcentaje).toFixed(0)}}%</td>
                    <td class="items-contenido center">
                        <div class="datos-iconos"
                            [ngClass]="{'green': item.varbudm >= 0, 'red' : item.varbudm < 0}">
                            <div>
                                <ng-container *ngIf="item.varbudm >= 0; else lessThanTen2">
                                    <img src="../../../../assets/iconos/triangle-green.svg">
                                </ng-container>
                                <ng-template #lessThanTen2>
                                    <img src="../../../../assets/iconos/triangle-red.svg">
                                </ng-template>
                            </div>
                            <div>
                                {{item.varbudm}}
                            </div>
                        </div>
                    </td>
                    <td class="items-contenido center">{{item.cantidadcliente}}</td>
                    <td class="items-contenido center">{{item.cantidadovs}}</td>
                </tr>
                <tr class="totales">
                    <td class="items-totales">Total</td>
                    <td class="items-totales center">{{getTotalCost('monto',dataReporteLinea)}}</td>
                    <td class="items-totales center">{{getTotalCost('cantidad',dataReporteLinea)}}</td>
                    <td class="items-totales center">{{((parseNumber(getTotalCost('cantidad',dataReporteLinea))
                        / parseNumber(getTotalCost('monto',dataReporteLinea))) * 100).toFixed(0) + '%'}}</td>
                    <td class="items-totales center">{{getTotalCost('varbudm',dataReporteLinea)}}</td>
                    <td class="items-totales center">{{getTotalCost('cantidadcliente',dataReporteLinea)}}</td>
                    <td class="items-totales center">{{getTotalCost('cantidadovs',dataReporteLinea)}}</td>
                </tr>
            </table>
        </div>
        <div class="a-w2 graficos" [ngClass]="{'sindata': TeuMesLineas.length <= 0}">
            <div class="titulos-graficos">TEU POR MES Y LINEA (2024)*</div>
            <canvas id="chartVentaTeuLinea" class="canvas-grafico">
                {{chartVentaTeuLinea}}
            </canvas>
        </div>
    </div>
    <div class="a-w1-row">
        <div class="a-w2 graficos"
            [ngClass]="{'sindata': dataReporteLinea2.length <= 0}">
            <div class="titulos-graficos">GENERAL POR MES (2024)*</div>
            <table>
                <tr class="cabecera">
                    <td class="items-cabecera center cabecera-cuadros">Mes</td>
                    <td class="items-cabecera center">*BudM</td>
                    <td class="items-cabecera center">TEU</td>
                    <td class="items-cabecera center">%BudM</td>
                    <td class="items-cabecera center">VarBudM</td>
                    <td class="items-cabecera center">Clientes</td>
                    <td class="items-cabecera center">OV</td>
                </tr>
                <tr *ngFor="let item of dataReporteLinea2; let i = index" class="contenido-final"
                    [ngClass]="{'sombra': (i % 2) == 0}">
                    <td class="items-contenido items-ejecutivos">{{item.entc_nomcompleto}}</td>
                    <td class="items-contenido center">
                        {{item.monto}}</td>
                    <td class="items-contenido center"
                        [ngClass]="{'red': item['cantidad'] < item['monto'],'green':item['cantidad'] >= item['monto']}">
                        {{item.cantidad}}</td>
                    <td class="items-contenido center"
                        [ngClass]="{'red': item['cantidad'] < item['monto'],'green':item['cantidad'] >= item['monto']}">
                        {{(item.porcentaje).toFixed(0)}}%</td>
                    <td class="items-contenido center">
                        <div class="datos-iconos"
                            [ngClass]="{'green': item.varbudm >= 0, 'red' : item.varbudm < 0}">
                            <div>
                                <ng-container *ngIf="item.varbudm >= 0; else lessThanTen2">
                                    <img src="../../../../assets/iconos/triangle-green.svg">
                                </ng-container>
                                <ng-template #lessThanTen2>
                                    <img src="../../../../assets/iconos/triangle-red.svg">
                                </ng-template>
                            </div>
                            <div>
                                {{item.varbudm}}
                            </div>
                        </div>
                    </td>
                    <td class="items-contenido center">{{item.cantidadcliente}}</td>
                    <td class="items-contenido center">{{item.cantidadovs}}</td>
                </tr>
                <tr class="totales">
                    <td class="items-totales">Total</td>
                    <td class="items-totales center">{{getTotalCost('monto',dataReporteLinea2)}}</td>
                    <td class="items-totales center">{{getTotalCost('cantidad',dataReporteLinea2)}}</td>
                    <td class="items-totales center">{{((parseNumber(getTotalCost('cantidad',dataReporteLinea2))
                        / parseNumber(getTotalCost('monto',dataReporteLinea2))) * 100).toFixed(0) + '%'}}</td>
                    <td class="items-totales center">{{getTotalCost('varbudm',dataReporteLinea2)}}</td>
                    <td class="items-totales center">{{getTotalCost('cantidadcliente',dataReporteLinea2)}}</td>
                    <td class="items-totales center">{{getTotalCost('cantidadovs',dataReporteLinea2)}}</td>
                </tr>
            </table>
        </div>
        <div class="a-w2 graficos" [ngClass]="{'sindata': TeuMesLineas.length <= 0}">
            <div class="titulos-graficos">TEU POR MES - TOTALES (2024)*</div>
            <canvas id="chartVentaTeuMensual" class="canvas-grafico">
                {{chartVentaTeuMensual}}
            </canvas>
        </div>
    </div>
    <div class="a-w1-row">
        <div class="a-w1 graficos" [ngClass]="{'sindata': TeuMesLineas.length <= 0}">
            <div class="titulos-graficos">TEU SEMANAL (2024)*</div>
            <canvas id="chartVentaTeuSemanal" class="canvas-grafico">
                {{chartVentaTeuSemanal}}
            </canvas>
        </div>
    </div>
</div>
<div class="a-footer"></div>